import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {initialState} from './Shared/Utils/Constants';
import {removeHTMLTags} from 'app/utilities/StringHelpers/StringHelpers';
import ProviderManager from 'app/provider/providerManager';
import {
    applyFilters,
    filterJobsByParams,
    isEmptyFilter,
    populationByLocationFilter,
    populationByScopeFilter,
    sortJobByIsHotJob,
} from 'app/Components/Page/CellcomCareersPage/Shared/Utils/HelperCareers';

export const SendResumeData = createAsyncThunk('cellcomCareers/sendResume', async (data, thunkAPI) => {
  try {
    console.log('SendResumeData', data);
    const result = await ProviderManager.getProviderData('sendResume', [
      data.jobId,
      data.firstName,
      data.lastName,
      data.email,
      data.phone,
      data.fileName,
      data.fileType,
      data.fileStream,
      data.city,
      data.sender,
      data.source,
    ]);
    return {
      isSuccess: result.Body,
    };
  } catch (error) {
    return {isSuccess: false, errorCode: '19'};
  }
});
export const getCities = createAsyncThunk('addressForm/getCities', async (data, thunkAPI) => {
    try {
        const result = await ProviderManager.getProviderData('getCities', []);
        return result.Body;
    } catch (error) {
        return error;
    }
});

const cellcomCareersSlice = createSlice({
    name: 'CellcomCareers',
    initialState,
    reducers: {
        initAds: (state, action) => {
            var adsCareersData = [];
            if (action?.payload && action.payload.length > 0) {
                action.payload
                    .filter((ad) => !ad.isHiddenAd?.value) // Filter out items where isHiddenAd is false
                    .map((ad) => {
                        var tempAd = {
                            title: ad.title?.value,
                            listAdLocation: ad.listOfCareerLocations?.value,
                            codeJob: ad.codeJob?.value,
                            description: ad.description?.value.length > 0 ? ad.description?.value : '',
                            requirements: ad.listRequirements?.value,
                            logoIcon: ad.logoIcon?.value,
                            utilJobs: ad.utilJobs?.value,
                            careerScope: ad.careersScope?.value.length > 0 ? ad.careersScope?.value.map((x) => x.careerScope) : '',
                            isHotAd: ad.isHotAd?.value,
                            isHiddenAd: ad.isHiddenAd?.value,
                            isResumeRequired: ad.isResumeRequired?.value === null ? false : ad.isResumeRequired.value,
                            niceToHave: ad.niceToHave?.value.length > 0 ? removeHTMLTags(ad.niceToHave?.value) : '',
                            whatsappNumber: ad.whatsappNumber?.value,
                            isOpenCollapse: false,
                            lastSaved: ad.saved,
                            bottomText: ad.footerSite?.value?.length > 0 ? ad.footerSite.value : '',
                            checked: false,
                        };
                        adsCareersData.push(tempAd);
                    });
            }
            return {
                ...state,
                adsCareersData: sortJobByIsHotJob(adsCareersData),
                isSuccess: true,
            };
        },
        initLocation: (state, action) => {
            if (action.payload && action.payload?.length > 0) {
                var filterLocationList = [];
                action.payload.map((location, index) => {
                    filterLocationList.push({
                        id: location.reigon,
                        label: location.reigon,
                        checked: false,
                        cities: location.cities
                    });
                });
                filterLocationList.push({id: 99, label: 'כל הארץ', checked: false});
            }

            var filterScopeList = [];
            state.careerScopeList.map((scope, index) => {
                filterScopeList.push({id: index, label: scope, checked: false});
            });
            return {
                ...state,
                careerScopeList: filterScopeList,
                locationCareersData: filterLocationList,
                isSuccess: true,
            };
        },
        initUtils: (state, action) => {
            console.log('initUtils', action.payload);
            state.utilsCareersData = action.payload;

            state.isSuccess = true;
        },
        initPageSetting: (state, action) => {
            var pageSetting = {
                mainTitle: removeHTMLTags(action.payload.mainTitle?.value),
                subTitle: removeHTMLTags(action.payload.subTitle?.value),
                jobTitle: removeHTMLTags(action.payload.jobTitle?.value),
                imgMobile: action.payload.backgroundImageMobile?.expandedValue?.url,
                imgDesktop: action.payload.backgroundImage?.expandedValue?.url,
            };
            var buttonData = {
                buttonSuccesUrl: action.payload.buttonSuccesUrl.value,
                buttonSuccesText: action.payload.buttonSuccesText.value,
                buttonFailedUrl: action.payload.buttonFailedUrl.value,
                buttonFailedText: action.payload.buttonFailedText.value,
            };
            return {
                ...state,
                pageCareersData: pageSetting,
                buttonData: buttonData,
            };
        },
        updateScopeChecked: (state, action) => {
            const {key, checked} = action.payload;
            const updateScope = state.careerScopeList.map((item) => {
                if (item.id === key) {
                    return {...item, checked: checked};
                } else {
                    return item;
                }
            });
            return {
                ...state,
                careerScopeList: updateScope,
                selectedScope: updateScope
                    .filter((scope) => {
                        if (scope.checked) return scope.label;
                    })
                    .map((y) => y.label),
            };
        },
        updateScopeFalse: (state, action) => {
            const updateScope = state.careerScopeList.map((item) => {
                return {...item, checked: false};
            });
            return {
                ...state,
                careerScopeList: updateScope,
                selectedScope: '',
                filterJobData: isEmptyFilter(state.selectedCities, state.selectedUtils, [], state.filterJobData),
            };
        },
        updateLocationChecked: (state, action) => {
            const {key, checked} = action.payload;

            // Update locationCareersData
            let updateLocation;
            if (key === 99) {
                // Set all items to checked: true when key is 99 and checked is true,
                // or set all items to checked: false when key is 99 and checked is false
                updateLocation = state.locationCareersData.map((item) => ({...item, checked}));
            } else {
                // Otherwise, update the specific item with the given key
                updateLocation = state.locationCareersData.map((item) => {
                    if (item.id === key) {
                        return {...item, checked};
                    } else {
                        return item;
                    }
                });
            }

            // Update locationsRegion
            const updatedRegions = checked ? [...state.locationsRegion, key] : state.locationsRegion.filter((item) => item !== key);

            // Update selectedCities
            const updatedCities = updateLocation.reduce((cities, region) => {
                if (region.checked && region.cities) {
                    region.cities.forEach((city) => cities.push(city.name));
                }
                return cities;
            }, []);

            // Update the Redux state
            return {
                ...state,
                locationCareersData: updateLocation,
                locationsRegion: updatedRegions,
                selectedCities: updatedCities,
            };
        },
        updateLocationFalse: (state, action) => {
            const updateLocation = state.locationCareersData.map((item) => {
                return {...item, checked: false};
            });
            return {
                ...state,
                locationCareersData: updateLocation,
                locationsRegion: [],
                selectedCities: [],
                filterJobData: isEmptyFilter([], state.selectedUtils, state.selectedScope, state.filterJobData),
            };
        },
        updateAdsByFilter: (state, action) => {
            const {selectedUtil, selectedCities, selectedScope, adsCareers, allUtil} = action.payload;
            const utils = selectedUtil !== undefined ? selectedUtil : state.selectedUtils;
            const scopes = selectedScope !== undefined ? selectedScope : state.selectedScope;
            const cities = selectedCities !== undefined ? selectedCities : state.selectedCities;
            if (selectedUtil && state.selectedUtils === selectedUtil) {
                return {
                    ...state,
                    selectedUtils: '',
                    filterJobData: filterJobsByParams(adsCareers, '', cities, scopes),
                };
            } else {
                return {
                    ...state,
                    selectedUtils: utils,
                    filterJobData: filterJobsByParams(adsCareers, utils, cities, scopes),
                };
            }
        },
        setCollapseJob: (state, action) => {
            const {codeJob, location, isOpen, isOnFilter} = action.payload;
            if (isOnFilter) {
                const updatedList = state.filterJobData.map((ad) => {
                    if (ad.codeJob === codeJob && JSON.stringify(ad.listAdLocation) === JSON.stringify(location)) {
                        return {
                            ...ad,
                            checked: !isOpen,
                        };
                    }
                    return ad;
                });
                return {
                    ...state,
                    filterJobData: updatedList,
                };
            } else {
                const updatedList = state.adsCareersData.map((ad) => {
                    if (ad.codeJob === codeJob && JSON.stringify(ad.listAdLocation) === JSON.stringify(location)) {
                        return {
                            ...ad,
                            checked: !isOpen,
                        };
                    }
                    return ad;
                });
                var restFilter = [];
                restFilter.push('SHOW_ALL');
                return {
                    ...state,
                    adsCareersData: updatedList,
                    filterJobData: restFilter,
                };
            }
        },
        saveSubmitData: (state, action) => {
            const {name, jobTitle} = action.payload;
            return {
                ...state,
                submitData: {
                    name: name,
                    title: jobTitle,
                },
            };
        },
    },

    extraReducers: {
        [SendResumeData.fulfilled]: (state, action) => {
            const {resultMessage, resultCode} = action.payload.isSuccess;
            if (resultMessage === 'SUCCESS' && resultCode === '0')
                return {
                    ...state,
                    resumeJobStatus: 'success',
                };
            return {
                ...state,
                resumeJobStatus: 'rejected',
            };
        },
        [SendResumeData.pending]: (state, action) => {
            return {
                ...state,
                resumeJobStatus: 'pending',
            };
        },
        [SendResumeData.rejected]: (state, action) => {
            return {
                ...state,
                resumeJobStatus: 'rejected',
            };
        },
        [getCities.fulfilled]: (state, action) => {
            if (action.payload.message !== '' && action.payload.message != undefined) {
                return;
            }

            //state.form.cities = action.payload;
            state.cities = action.payload;
        },
    },
});

export const {
    initAds,
    initLocation,
    initUtils,
    initPageSetting,
    cities,
    setSelectedUtils,
    setSelectedScope,
    setCollapseJob,
    setLocationFilter,
    updateLocationChecked,
    updateScopeChecked,
    updateAdsByFilter,
    saveSubmitData,
    updateLocationFalse,
    updateScopeFalse,
} = cellcomCareersSlice.actions;
export default cellcomCareersSlice.reducer;
